import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <Header />
      <main className="privacy-content">
        <h1>Privacy Policy & Terms of Service</h1>
        <p className="privacy-updated">Last updated: March 2026</p>

        <section>
          <h2>About LeasEiZi</h2>
          <p>
            LeasEiZi is an apartment lease price tracking service. Users submit their email address
            and the details of specific apartments they want to monitor. LeasEiZi tracks price
            changes and notifies users when prices drop or reach their target price.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <p>When you submit a tracking request through LeasEiZi, we collect:</p>
          <ul>
            <li>Your email address</li>
            <li>Your name</li>
            <li>Apartment details you provide (unit, floor plan, target price, lease start date, listing URL)</li>
          </ul>
          <p>
            We do not collect payment information, social security numbers, or any government
            identification. We do not track your browsing activity beyond what is necessary to
            operate the service.
          </p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use your information solely to:</p>
          <ul>
            <li>Send you a welcome confirmation when you submit a tracking request</li>
            <li>Notify you when the price of an apartment you are tracking decreases</li>
            <li>Notify you when the price of an apartment you are tracking reaches your target price</li>
          </ul>
          <p>
            We do not sell, rent, share, or transfer your personal information to third parties
            for marketing purposes. Your email address is used only to deliver the alerts you
            explicitly requested.
          </p>
        </section>

        <section>
          <h2>Opt-In Consent</h2>
          <p>
            All emails sent by LeasEiZi are transactional and triggered exclusively by your
            explicit submission of a tracking request through our website. We do not add users
            to any mailing list without their direct action. There are no pre-checked boxes or
            implied consent — you only receive emails because you submitted a form on leaseizi.com
            requesting price alerts for a specific apartment.
          </p>
        </section>

        <section>
          <h2>Unsubscribe & Data Removal</h2>
          <p>
            Every email sent by LeasEiZi includes an <strong>Unsubscribe</strong> link in the
            footer. Clicking it will immediately remove your email from all future LeasEiZi
            alerts. We also support one-click unsubscribe via the email header
            (List-Unsubscribe), compatible with Gmail and Yahoo Mail.
          </p>
          <p>
            To request complete removal of your data from our systems, email us at{' '}
            <a href="mailto:support@leaseizi.com">support@leaseizi.com</a>.
          </p>
        </section>

        <section>
          <h2>Data Retention</h2>
          <p>
            Your tracking preferences are retained until you unsubscribe or request deletion.
            We do not retain your data after removal is requested.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            For any privacy questions or data removal requests, contact us at{' '}
            <a href="mailto:support@leaseizi.com">support@leaseizi.com</a>.
          </p>
        </section>

        <hr />

        <section>
          <h2>Terms of Service</h2>
          <p>
            By submitting a tracking request on LeasEiZi, you agree to the following:
          </p>
          <ul>
            <li>
              You are submitting your own email address and consenting to receive price alert
              emails for the apartments you specify.
            </li>
            <li>
              LeasEiZi provides apartment price tracking as an informational service only. We do
              not guarantee the accuracy of pricing data, availability of apartments, or any
              specific outcome from using the service.
            </li>
            <li>
              LeasEiZi is not affiliated with any apartment complex, property management company,
              or real estate service.
            </li>
            <li>
              You may unsubscribe at any time using the link in any email we send you.
            </li>
            <li>
              LeasEiZi reserves the right to discontinue the service at any time.
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
